import React from 'react';
import { Box, FormControl, Grid, IconButton, MenuItem, Select, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import { MobileButton } from "../../../components";
import multiItemQuestionnaireWithLocalStorage from './MultiItemQuestionairePage.component';

import { arrayOfNumbers } from "../../../services/util.service";
import { fertilityTreatments } from "../../../data/db";

import useStyles from "./MultiItemQuestionnaire.style";

import PregnancyTestIcon from "../../../images/pregnancytest.svg";

const FertilityTreatmentQuestionnaire = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const currentYear = new Date(Date.now()).getFullYear();
    const firstMenstruationYear = parseInt(localStorage.getItem('firstMenstruationAge') || props.firstMenstruationYear);

    return (
        <>
            <Box className={classes.questionnaire}>
                <Box className={classes.questionnaireHeader}>
                    <span>{t('common.substantive.treatment')} #{props.index + 1}</span>
                    <IconButton aria-label="delete" color="inherit" onClick={props.onFertilityTreatmentRemove}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
                <Box className={classes.questionnaireBody}>
                    <Box className={classes.questionaireQuestionSet}>
                        <Box className={classes.questionnaireQuestion}>
                            {t('common.substantive.treatment')}
                        </Box>
                        <FormControl variant="outlined" fullWidth>
                            <Select value={props.data.treatment} onChange={props.onTreatmentChange}>
                                {fertilityTreatments.map(treatment =>
                                    <MenuItem key={treatment} value={treatment}>{treatment}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={6} className={classes.questionaireQuestionSet}>
                            <Box className={classes.questionnaireQuestion}>
                                {t('common.substantive.year')}
                            </Box>
                            <FormControl variant="outlined" fullWidth>
                                <Select value={props.data.year} onChange={props.onYearChange}>
                                    {arrayOfNumbers(firstMenstruationYear, currentYear - firstMenstruationYear + 1)
                                        .map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
};

const Page11 = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <>
            <Box className={classes.svgIconSection}>
                <img src={PregnancyTestIcon} alt="Pregnancy Test icon" className={classes.svgIcon} style={{ width: 100 }} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('repliQuestionnaire.general.fertilityTreatmentQuestion')}
                </Typography>
            </Box>
            {
                props.items.map((data, i) =>
                    <FertilityTreatmentQuestionnaire
                        key={i}
                        index={i}
                        data={data}
                        firstMenstruationYear={props.profile.firstMenstruationYear}
                        onFertilityTreatmentRemove={props.onRemove(i)}
                        onTreatmentChange={props.onChange(i, 'treatment')}
                        onYearChange={props.onChange(i, 'year')}
                    />
                )
            }
            <MobileButton
                label={t('common.form.button.addNew')}
                startIcon={<AddIcon />}
                onClick={props.onAdd}
            />
        </>
    );
};

const defaultFertilityTreatmentEntry = {
    treatment: '',
    year: ''
};

export default multiItemQuestionnaireWithLocalStorage(
    Page11,
    defaultFertilityTreatmentEntry,
    'fertilityTreatments'
);